import { merge } from 'lodash';
import axios from 'axios';
import Cookies from 'js-cookie';

export const buildHeaders = (contentType) => {
  const token = document.querySelector('meta[name="csrf-token"]')?.content;
  const oppfiCsrfToken = Cookies.get('_oppfi_csrf');
  return {
    'Content-Type': contentType,
    'X-CSRF-Token': token,
    'X-Oppfi-Csrf-Token': oppfiCsrfToken
  };
};

const handleSessionTimeout = (e) => {
  if (
    e.config &&
    e.response &&
    e.config.url &&
    e.config.url.startsWith('/portal/api') &&
    e.response.status === 401
  ) {
    window.location.href = '/auth/logout';
  } else {
    throw e;
  }
};

export const getData = ({ url, contentType = 'application/json' }) => {
  return axios
    .get(url, { headers: buildHeaders(contentType) })
    .catch(handleSessionTimeout);
};

export const postData = ({
  url,
  body,
  contentType = 'application/json',
  catchErrors = true,
  config = {}
}) => {
  const options = merge({ headers: buildHeaders(contentType) }, config);
  if (!catchErrors) {
    options.validateStatus = () => true;
  }

  return axios.post(url, body, options).catch(handleSessionTimeout);
};

export const putData = ({ url, body, contentType = 'application/json' }) => {
  return axios
    .put(url, body, { headers: buildHeaders(contentType) })
    .catch(handleSessionTimeout);
};
